export default __webpack_public_path__ + "static/media/icon-white.47274140.png";